import React, { useEffect } from 'react';
import { Layout, Breadcrumb, Empty } from 'antd';
import * as S from './Favourites.styled';
import { IsAcceptedSelector, IsOwnerSelector, IsManagerSelector } from 'features/User/UserSlice';
import Meta from 'components/Meta';
import { useAppDispatch } from 'hooks/useStore';
import { useSelector } from 'react-redux';
import { fetchFavourites } from 'features/FavouritesList/FavouritesListSlice';
import FavouritesList from 'features/FavouritesList';

const { Content } = Layout;

const Favourites: React.FC = () => {
	const dispatch = useAppDispatch();

	// Подтвержденность пользователя
	const isAccepted = useSelector(IsAcceptedSelector);
	const isManager = useSelector(IsManagerSelector);
	const isOwner = useSelector(IsOwnerSelector);

	useEffect(() => {
		if (isOwner || (isAccepted && isManager)) dispatch(fetchFavourites());
	}, [dispatch, isAccepted, isManager, isOwner]);

	return (
		<>
			<Meta pageName="requests" />
			<Content
				style={{
					padding: '0px 20px 20px 20px',
					display: 'flex',
					flexDirection: 'column',
				}}>
				<Breadcrumb
					items={[{ title: 'realty platform' }, { title: 'favourites' }]}
					style={{ margin: '16px 0' }}
				/>
				<S.WorkSpace>
					{isOwner || (isAccepted && isManager) ? (
						<FavouritesList />
					) : (
						<S.Empty>
							<Empty
								image={Empty.PRESENTED_IMAGE_SIMPLE}
								description="You do not have the necessary rights to view this section"
							/>
						</S.Empty>
					)}
				</S.WorkSpace>
			</Content>
		</>
	);
};

export default Favourites;
